import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const UPDATE_LAW_DOCS = "UPDATE_LAW_DOCS";
export const UPDATE_LAW_DOCS_LOADING =
"UPDATE_LAW_DOCS_LOADING";
export const UPDATE_LAW_DOCS_LOADING_FAILED =
"UPDATE_LAW_DOCS_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const updateLawDocsLoading = ms => ({
    type: UPDATE_LAW_DOCS_LOADING,
    payload: ms
    });
    
    export const updateLawDocsLoadingFailed = ms => ({
    type: UPDATE_LAW_DOCS_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function updateLawDocs(obj) {
    const request = axios.post(
    `https://prod-legalemirates.wowets.com/fileService/legalPenalRoutes/api/v1/lawDocuments/updateLawDocumentById`,obj, {
        headers: { 'Authorization': 'bearer ' +localStorage.consultantToken}
      });
    return dispatch => {

    dispatch(updateLawDocsLoading());
    request
    .then(response => {   
  
    if (response.status == 201 || response.status == 200) {
     console.log(response,"response updateLawDocs")
    dispatch({
    type: UPDATE_LAW_DOCS,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        updateLawDocsLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(updateLawDocsLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(updateLawDocsLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(updateLawDocsLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


